<template>
    <SfSection
        layout="text-image"
        :orientation="orientation"
    >
        <template v-slot:default>
            <h2
                v-if="sectionTitle"
                class="text-image__title"
            >
                {{ sectionTitle }}
            </h2>
            <!-- eslint-disable -->
            <div
                v-if="richText"
                v-html="richText"
                class="article text-image__text"
            />
            <!-- eslint-enable -->

            <sf-button
                v-if="hasCta"
                element="a"
                :href="ctaHref"
                :target="isExternalLink ? '_blank' : undefined"
            >
                <template v-slot:pre><sf-icon icon="arrow-right" /></template>
                <template v-slot:default>{{ ctaLabel }}</template>
            </sf-button>
        </template>

        <template v-slot:aside>
            <LazyImg
                v-if="image"
                :src="image.url_sm"
                :src-tiny="image.url_tiny"
                :srcset="`
                    ${image.url_xs} 320w,
                    ${image.url_sm} 600w,
                    ${image.url_md} 800w,
                    ${image.url_lg} 1280w
                `"
                sizes="
                    (max-width: 380px) 320px,
                    50vw
                "
                :width="image.width"
                :height="image.height"
                :alt="image.alt || ''"
                :caption="caption"
                :has-focal-point="image?.hasFocalPoint"
                :focal-point="image?.focalPoint"
            />
        </template>
    </SfSection>
</template>

<script>
import { get } from 'lodash-es';

import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';
import LazyImg from '~/patterns/atoms/lazy-img/lazy-img';
import SfButton from '~/patterns/atoms/button/button';
import SfIcon from '~/patterns/atoms/icon/icon';
import { urlToPath } from '~/utils/urlToPath.js';

export default {
    components: {
        SfSection,
        LazyImg,
        SfButton,
        SfIcon
    },

    mixins: [
        contentBlockMixin
    ],

    computed: {
        sectionTitle() {
            return get(this, 'block.sectionTitle', '');
        },

        image() {
            return get(this, 'block.image.0', null);
        },

        richText() {
            return get(this, 'block.wysiwyg', '');
        },

        caption() {
            return get(this, 'block.caption', '');
        },

        orientation() {
            return get(this, 'block.imageAlignment', 'left');
        },

        ctaEntryLink() {
            const entryLink = get(this, 'block.ctaEntryLink', []);
            return entryLink && entryLink.length > 0 ? entryLink[0] : null;
        },

        ctaExternalUrl() {
            return get(this, 'block.ctaExternalUrl', null);
        },

        hasCta() {
            return this.ctaEntryLink || this.ctaExternalUrl;
        },

        ctaHref() {
            if (this.ctaEntryLink) {
                return urlToPath(this.ctaEntryLink.url);
            }
            else if (this.ctaExternalUrl) {
                return this.ctaExternalUrl;
            }
            return null;
        },

        ctaLabel() {
            const label = get(this, 'block.ctaLabel');
            return label || this.$t('cta.readMore');
        },

        isExternalLink() {
            return !!this.ctaExternalUrl;
        }
    }
};
</script>


<style lang="less">
.text-image__title {
    margin-bottom: var(--spacing-xl);

    @media @q-md-min {
        margin-bottom: var(--spacing-2xl);
    }
}

.text-image__text {
    margin-bottom: var(--spacing-xl);

    @media @q-md-min {
        margin-bottom: var(--spacing-2xl);
    }
}
</style>
